import { makeRoute } from '~/utils/route';
import DashboardController from './dashboard.controller';
import template from './dashboard.html';
import './dashboard.scss';

export default makeRoute({
	path: '/dashboard/:kid',
	template,
	controller: DashboardController,
	// La sélection d'une ligne de widget est reflétée dans l'URL (?selected=) :
	// sans ceci, chaque clic rechargerait le tableau de bord entier.
	reloadOnSearch: false,
	title: 'TDB',
});
